import { Types } from "@grandvisionhq/graphql";
const UnavailableLineItemCodes = [
  Types.ValidationCode.PRODUCTS_ARE_NOT_EXCLUDED_FROM_CHECKOUT,
  Types.ValidationCode.IS_VALID_QUANTITY,
  Types.ValidationCode.IS_IN_STOCK
];
function getValidationErrorsByLineItem(validationInput) {
  if (!validationInput) {
    return void 0;
  }
  const lineItemValidationErrors = validationInput.cartLineItemErrors;
  if (!lineItemValidationErrors) {
    return void 0;
  }
  const unavailableLineItems = {};
  for (const lineItem of lineItemValidationErrors) {
    const codes = lineItem.errors.map((error) => error.validationCode).filter((code) => UnavailableLineItemCodes.includes(code));
    if (codes.length > 0) {
      unavailableLineItems[lineItem.itemId] = codes;
    }
  }
  return Object.keys(unavailableLineItems).length > 0 ? unavailableLineItems : void 0;
}
export {
  getValidationErrorsByLineItem
};
//# sourceMappingURL=get-validation-errors-by-line-item.js.map
